var map = {
	"./": 57895,
	"./Configuration": 56334,
	"./Configuration.js": 56334,
	"./Unknown": 40391,
	"./Unknown.js": 40391,
	"./UnknownClientSide": 15132,
	"./UnknownClientSide.js": 15132,
	"./UnknownClientSide.test": 23151,
	"./UnknownClientSide.test.js": 23151,
	"./chemistry/BandNode": 20804,
	"./chemistry/BandNode.js": 20804,
	"./chemistry/BoilingPointSolutionModeler": 17956,
	"./chemistry/BoilingPointSolutionModeler.js": 17956,
	"./chemistry/BoilingPointSolutionModeler.test": 46789,
	"./chemistry/BoilingPointSolutionModeler.test.js": 46789,
	"./chemistry/BunsenBurner": 68336,
	"./chemistry/BunsenBurner.js": 68336,
	"./chemistry/ColorCHSV": 46319,
	"./chemistry/ColorCHSV.js": 46319,
	"./chemistry/Constants": 71712,
	"./chemistry/Constants.js": 71712,
	"./chemistry/Constants.test": 74781,
	"./chemistry/Constants.test.js": 74781,
	"./chemistry/Cooling": 58636,
	"./chemistry/Cooling.js": 58636,
	"./chemistry/Cooling.test": 49952,
	"./chemistry/Cooling.test.js": 49952,
	"./chemistry/EquilibriumSettings": 75647,
	"./chemistry/EquilibriumSettings.js": 75647,
	"./chemistry/FreezingPointSolutionModeler": 34955,
	"./chemistry/FreezingPointSolutionModeler.js": 34955,
	"./chemistry/KnowledgeBase": 59129,
	"./chemistry/KnowledgeBase.js": 59129,
	"./chemistry/LiquidVolumeSolutionModeler": 73850,
	"./chemistry/LiquidVolumeSolutionModeler.js": 73850,
	"./chemistry/Reaction": 31953,
	"./chemistry/Reaction.js": 31953,
	"./chemistry/Reaction.test": 33926,
	"./chemistry/Reaction.test.js": 33926,
	"./chemistry/ReactionKinetics": 80644,
	"./chemistry/ReactionKinetics.js": 80644,
	"./chemistry/ReactionKinetics.test": 60182,
	"./chemistry/ReactionKinetics.test.js": 60182,
	"./chemistry/ReactionNode": 61470,
	"./chemistry/ReactionNode.js": 61470,
	"./chemistry/ReactionNode.test": 4916,
	"./chemistry/ReactionNode.test.js": 4916,
	"./chemistry/ReactionNodeHelpers.test": 1910,
	"./chemistry/ReactionNodeHelpers.test.js": 1910,
	"./chemistry/ReactionNodeKinetics": 23963,
	"./chemistry/ReactionNodeKinetics.js": 23963,
	"./chemistry/ReactionNodeKinetics.test": 80757,
	"./chemistry/ReactionNodeKinetics.test.js": 80757,
	"./chemistry/ReactionNodeKineticsNotes.md": 86201,
	"./chemistry/ReactionNodeTestGlucose.test": 7986,
	"./chemistry/ReactionNodeTestGlucose.test.js": 7986,
	"./chemistry/RungeKutta4": 87928,
	"./chemistry/RungeKutta4.js": 87928,
	"./chemistry/RungeKutta4.test": 95700,
	"./chemistry/RungeKutta4.test.js": 95700,
	"./chemistry/Solution": 41374,
	"./chemistry/Solution.js": 41374,
	"./chemistry/Solution.test": 40275,
	"./chemistry/Solution.test.js": 40275,
	"./chemistry/SolutionEq.test": 82557,
	"./chemistry/SolutionEq.test.js": 82557,
	"./chemistry/SolutionEqRedox.test": 36331,
	"./chemistry/SolutionEqRedox.test.js": 36331,
	"./chemistry/SolutionRev": 9825,
	"./chemistry/SolutionRev.js": 9825,
	"./chemistry/SolutionRevEq.test": 64426,
	"./chemistry/SolutionRevEq.test.js": 64426,
	"./chemistry/SolutionVessel.test": 39658,
	"./chemistry/SolutionVessel.test.js": 39658,
	"./chemistry/SolventConcentrationSolutionModeler": 95808,
	"./chemistry/SolventConcentrationSolutionModeler.js": 95808,
	"./chemistry/SolventSolutionModeler": 98155,
	"./chemistry/SolventSolutionModeler.js": 98155,
	"./chemistry/SpecieState": 54803,
	"./chemistry/SpecieState.js": 54803,
	"./chemistry/Species": 39479,
	"./chemistry/Species.js": 39479,
	"./chemistry/Species.test": 69939,
	"./chemistry/Species.test.js": 69939,
	"./chemistry/SpeciesNode": 40922,
	"./chemistry/SpeciesNode.js": 40922,
	"./chemistry/SpeciesNode.test": 21263,
	"./chemistry/SpeciesNode.test.js": 21263,
	"./chemistry/SpeciesNodeMoleFraction.test": 91110,
	"./chemistry/SpeciesNodeMoleFraction.test.js": 91110,
	"./chemistry/SpecificHeatSolutionMod": 49510,
	"./chemistry/SpecificHeatSolutionMod.js": 49510,
	"./chemistry/SpecificHeatSolutionMod.test": 17277,
	"./chemistry/SpecificHeatSolutionMod.test.js": 17277,
	"./chemistry/SpecificHeatSolutionModeler": 51578,
	"./chemistry/SpecificHeatSolutionModeler.js": 51578,
	"./chemistry/SpecificHeatSolutionModeler.test": 90619,
	"./chemistry/SpecificHeatSolutionModeler.test.js": 90619,
	"./chemistry/SpecificHeatSolutionModelerSolvent.test": 66595,
	"./chemistry/SpecificHeatSolutionModelerSolvent.test.js": 66595,
	"./chemistry/SpectrumColor": 87220,
	"./chemistry/SpectrumColor.js": 87220,
	"./chemistry/WeightSolutionModeler": 1719,
	"./chemistry/WeightSolutionModeler.js": 1719,
	"./chemistry/algoNotes1.txt": 37727,
	"./chemistry/almostEq": 66348,
	"./chemistry/almostEq.js": 66348,
	"./chemistry/ex": 26067,
	"./chemistry/ex.json": 26067,
	"./chemistry/getIndex": 85271,
	"./chemistry/getIndex.js": 85271,
	"./chemistry/sum": 36461,
	"./chemistry/sum.js": 36461,
	"./collections/Tool": 35523,
	"./collections/Tool.js": 35523,
	"./collections/Vessel": 95785,
	"./collections/Vessel.js": 95785,
	"./collections/Workbench": 26796,
	"./collections/Workbench.js": 26796,
	"./index": 57895,
	"./index.js": 57895,
	"./labInfo": 75256,
	"./labInfo.js": 75256,
	"./library": 73969,
	"./library.js": 73969,
	"./logging/XMLLogger": 71089,
	"./logging/XMLLogger.js": 71089,
	"./logging/XMLUtility": 62420,
	"./logging/XMLUtility.js": 62420,
	"./long-press-event.min": 44201,
	"./long-press-event.min.js": 44201,
	"./models/App": 41099,
	"./models/App.js": 41099,
	"./models/InstrumentPanel": 48254,
	"./models/InstrumentPanel.js": 48254,
	"./models/Solution": 34367,
	"./models/Solution.js": 34367,
	"./models/Tool": 33769,
	"./models/Tool.js": 33769,
	"./models/Vessel": 51074,
	"./models/Vessel.js": 51074,
	"./models/Workbench": 39397,
	"./models/Workbench.js": 39397,
	"./resources/assignment data translation.txt": 22101,
	"./resources/assignments": 88900,
	"./resources/assignments.js": 88900,
	"./resources/assignments/en/MolarityDensity/dilution/assignment": 81610,
	"./resources/assignments/en/MolarityDensity/dilution/assignment.json": 81610,
	"./resources/assignments/en/MolarityDensity/dilution/configuration": 66118,
	"./resources/assignments/en/MolarityDensity/dilution/configuration.json": 66118,
	"./resources/assignments/en/MolarityDensity/dilution/reactions": 44810,
	"./resources/assignments/en/MolarityDensity/dilution/reactions.json": 44810,
	"./resources/assignments/en/MolarityDensity/dilution/solutions": 16731,
	"./resources/assignments/en/MolarityDensity/dilution/solutions.json": 16731,
	"./resources/assignments/en/MolarityDensity/dilution/species": 38636,
	"./resources/assignments/en/MolarityDensity/dilution/species.json": 38636,
	"./resources/assignments/en/MolarityDensity/dilution/spectra": 93032,
	"./resources/assignments/en/MolarityDensity/dilution/spectra.json": 93032,
	"./resources/assignments/en/MolarityDensity/sucrose/assignment": 96798,
	"./resources/assignments/en/MolarityDensity/sucrose/assignment.json": 96798,
	"./resources/assignments/en/MolarityDensity/sucrose/configuration": 38765,
	"./resources/assignments/en/MolarityDensity/sucrose/configuration.json": 38765,
	"./resources/assignments/en/MolarityDensity/sucrose/reactions": 92078,
	"./resources/assignments/en/MolarityDensity/sucrose/reactions.json": 92078,
	"./resources/assignments/en/MolarityDensity/sucrose/solutions": 10635,
	"./resources/assignments/en/MolarityDensity/sucrose/solutions.json": 10635,
	"./resources/assignments/en/MolarityDensity/sucrose/species": 6657,
	"./resources/assignments/en/MolarityDensity/sucrose/species.json": 6657,
	"./resources/assignments/en/MolarityDensity/sucrose/spectra": 8694,
	"./resources/assignments/en/MolarityDensity/sucrose/spectra.json": 8694,
	"./resources/assignments/en/Redox/redox/assignment": 19492,
	"./resources/assignments/en/Redox/redox/assignment.json": 19492,
	"./resources/assignments/en/Redox/redox/configuration": 7333,
	"./resources/assignments/en/Redox/redox/configuration.json": 7333,
	"./resources/assignments/en/Redox/redox/reactions": 51024,
	"./resources/assignments/en/Redox/redox/reactions.json": 51024,
	"./resources/assignments/en/Redox/redox/solutions": 6351,
	"./resources/assignments/en/Redox/redox/solutions.json": 6351,
	"./resources/assignments/en/Redox/redox/species": 90806,
	"./resources/assignments/en/Redox/redox/species.json": 90806,
	"./resources/assignments/en/Redox/redox/spectra": 65167,
	"./resources/assignments/en/Redox/redox/spectra.json": 65167,
	"./resources/assignments/en/Redox/redox2/assignment": 15220,
	"./resources/assignments/en/Redox/redox2/assignment.json": 15220,
	"./resources/assignments/en/Redox/redox2/configuration": 3420,
	"./resources/assignments/en/Redox/redox2/configuration.json": 3420,
	"./resources/assignments/en/Redox/redox2/reactions": 65639,
	"./resources/assignments/en/Redox/redox2/reactions.json": 65639,
	"./resources/assignments/en/Redox/redox2/solutions": 58888,
	"./resources/assignments/en/Redox/redox2/solutions.json": 58888,
	"./resources/assignments/en/Redox/redox2/species": 19411,
	"./resources/assignments/en/Redox/redox2/species.json": 19411,
	"./resources/assignments/en/Redox/redox2/spectra": 67976,
	"./resources/assignments/en/Redox/redox2/spectra.json": 67976,
	"./resources/assignments/en/chem207/exp01/assignment": 83379,
	"./resources/assignments/en/chem207/exp01/assignment.json": 83379,
	"./resources/assignments/en/chem207/exp01/configuration": 62833,
	"./resources/assignments/en/chem207/exp01/configuration.json": 62833,
	"./resources/assignments/en/chem207/exp01/reactions": 34174,
	"./resources/assignments/en/chem207/exp01/reactions.json": 34174,
	"./resources/assignments/en/chem207/exp01/solutions": 24069,
	"./resources/assignments/en/chem207/exp01/solutions.json": 24069,
	"./resources/assignments/en/chem207/exp01/species": 23682,
	"./resources/assignments/en/chem207/exp01/species.json": 23682,
	"./resources/assignments/en/chem207/exp01/spectra": 97117,
	"./resources/assignments/en/chem207/exp01/spectra.json": 97117,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/assignment": 52288,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/assignment.json": 52288,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/configuration": 95419,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/configuration.json": 95419,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/reactions": 14192,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/reactions.json": 14192,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/solutions": 61087,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/solutions.json": 61087,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/species": 79391,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/species.json": 79391,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/spectra": 58900,
	"./resources/assignments/en/chemvlab/IV/IV_dilute_saline/spectra.json": 58900,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/assignment": 22037,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/assignment.json": 22037,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/configuration": 89672,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/configuration.json": 89672,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/reactions": 51566,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/reactions.json": 51566,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/solutions": 60540,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/solutions.json": 60540,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/species": 32997,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/species.json": 32997,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/spectra": 83448,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_12/spectra.json": 83448,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/assignment": 13304,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/assignment.json": 13304,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/configuration": 10780,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/configuration.json": 10780,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/reactions": 99135,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/reactions.json": 99135,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/solutions": 66601,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/solutions.json": 66601,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/species": 79549,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/species.json": 79549,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/spectra": 87254,
	"./resources/assignments/en/chemvlab/IV/IV_iodine_18/spectra.json": 87254,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/assignment": 58270,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/assignment.json": 58270,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/configuration": 53953,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/configuration.json": 53953,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/reactions": 37164,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/reactions.json": 37164,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/solutions": 48426,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/solutions.json": 48426,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/species": 41796,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/species.json": 41796,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/spectra": 93275,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose/spectra.json": 93275,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/assignment": 5747,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/assignment.json": 5747,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/configuration": 44689,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/configuration.json": 44689,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/reactions": 30150,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/reactions.json": 30150,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/solutions": 68465,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/solutions.json": 68465,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/species": 3651,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/species.json": 3651,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/spectra": 52731,
	"./resources/assignments/en/chemvlab/IV/IV_make_glucose2/spectra.json": 52731,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/assignment": 50653,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/assignment.json": 50653,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/configuration": 27621,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/configuration.json": 27621,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/reactions": 90442,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/reactions.json": 90442,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/solutions": 20371,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/solutions.json": 20371,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/species": 92763,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/species.json": 92763,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/spectra": 50051,
	"./resources/assignments/en/chemvlab/IV/IV_make_saline/spectra.json": 50051,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/assignment": 87196,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/assignment.json": 87196,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/configuration": 42543,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/configuration.json": 42543,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/reactions": 67402,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/reactions.json": 67402,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/solutions": 5849,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/solutions.json": 5849,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/species": 77057,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/species.json": 77057,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/spectra": 5499,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_a/spectra.json": 5499,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/assignment": 59410,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/assignment.json": 59410,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/configuration": 82697,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/configuration.json": 82697,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/reactions": 36834,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/reactions.json": 36834,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/solutions": 46526,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/solutions.json": 46526,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/species": 35421,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/species.json": 35421,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/spectra": 25309,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity1_b/spectra.json": 25309,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/assignment": 66661,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/assignment.json": 66661,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/configuration": 87706,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/configuration.json": 87706,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/reactions": 63368,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/reactions.json": 63368,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/solutions": 72545,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/solutions.json": 72545,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/species": 22983,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/species.json": 22983,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/spectra": 66414,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_a/spectra.json": 66414,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/assignment": 89814,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/assignment.json": 89814,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/configuration": 26662,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/configuration.json": 26662,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/reactions": 35772,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/reactions.json": 35772,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/solutions": 71546,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/solutions.json": 71546,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/species": 69883,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/species.json": 69883,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/spectra": 51096,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_b/spectra.json": 51096,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/assignment": 85346,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/assignment.json": 85346,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/configuration": 94170,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/configuration.json": 94170,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/reactions": 85948,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/reactions.json": 85948,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/solutions": 28542,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/solutions.json": 28542,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/species": 9931,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/species.json": 9931,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/spectra": 88095,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity2_c/spectra.json": 88095,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/assignment": 3126,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/assignment.json": 3126,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/configuration": 8621,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/configuration.json": 8621,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/reactions": 7267,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/reactions.json": 7267,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/solutions": 43254,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/solutions.json": 43254,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/species": 72212,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/species.json": 72212,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/spectra": 34287,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_a/spectra.json": 34287,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/assignment": 89395,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/assignment.json": 89395,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/configuration": 55002,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/configuration.json": 55002,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/reactions": 43608,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/reactions.json": 43608,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/solutions": 35390,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/solutions.json": 35390,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/species": 70430,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/species.json": 70430,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/spectra": 19726,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_b/spectra.json": 19726,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/assignment": 49195,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/assignment.json": 49195,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/configuration": 8526,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/configuration.json": 8526,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/reactions": 64927,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/reactions.json": 64927,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/solutions": 105,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/solutions.json": 105,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/species": 13264,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/species.json": 13264,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/spectra": 59996,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_c/spectra.json": 59996,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/assignment": 6057,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/assignment.json": 6057,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/configuration": 47192,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/configuration.json": 47192,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/reactions": 20602,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/reactions.json": 20602,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/solutions": 72629,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/solutions.json": 72629,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/species": 49547,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/species.json": 49547,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/spectra": 94684,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_d/spectra.json": 94684,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/assignment": 36767,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/assignment.json": 36767,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/configuration": 24268,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/configuration.json": 24268,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/reactions": 45476,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/reactions.json": 45476,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/solutions": 87481,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/solutions.json": 87481,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/species": 98956,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/species.json": 98956,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/spectra": 91515,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity3_e/spectra.json": 91515,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/assignment": 35246,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/assignment.json": 35246,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/configuration": 48205,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/configuration.json": 48205,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/reactions": 70002,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/reactions.json": 70002,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/solutions": 4433,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/solutions.json": 4433,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/species": 69585,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/species.json": 69585,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/spectra": 79004,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_a/spectra.json": 79004,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/assignment": 91018,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/assignment.json": 91018,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/configuration": 97586,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/configuration.json": 97586,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/reactions": 75061,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/reactions.json": 75061,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/solutions": 2534,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/solutions.json": 2534,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/species": 18297,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/species.json": 18297,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/spectra": 74551,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_b/spectra.json": 74551,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/assignment": 95010,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/assignment.json": 95010,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/configuration": 87520,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/configuration.json": 87520,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/reactions": 41712,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/reactions.json": 41712,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/solutions": 30921,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/solutions.json": 30921,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/species": 32548,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/species.json": 32548,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/spectra": 58218,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_c/spectra.json": 58218,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/assignment": 21320,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/assignment.json": 21320,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/configuration": 70894,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/configuration.json": 70894,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/reactions": 27750,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/reactions.json": 27750,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/solutions": 13574,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/solutions.json": 13574,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/species": 20742,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/species.json": 20742,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/spectra": 38663,
	"./resources/assignments/en/chemvlab/stoichiometry/Activity4_d/spectra.json": 38663,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/assignment": 57032,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/assignment.json": 57032,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/configuration": 85066,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/configuration.json": 85066,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/reactions": 54989,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/reactions.json": 54989,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/solutions": 17125,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/solutions.json": 17125,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/species": 14610,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/species.json": 14610,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/spectra": 22362,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_ga/spectra.json": 22362,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/assignment": 91048,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/assignment.json": 91048,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/configuration": 87682,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/configuration.json": 87682,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/reactions": 83206,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/reactions.json": 83206,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/solutions": 80194,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/solutions.json": 80194,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/species": 77666,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/species.json": 77666,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/spectra": 89187,
	"./resources/assignments/en/chemvlab/stoichiometry/chloride_precip/spectra.json": 89187,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/assignment": 78689,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/assignment.json": 78689,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/configuration": 66706,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/configuration.json": 66706,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/reactions": 52379,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/reactions.json": 52379,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/solutions": 82398,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/solutions.json": 82398,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/species": 52467,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/species.json": 52467,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/spectra": 16932,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_ga/spectra.json": 16932,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/assignment": 12897,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/assignment.json": 12897,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/configuration": 79606,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/configuration.json": 79606,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/reactions": 84162,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/reactions.json": 84162,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/solutions": 52022,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/solutions.json": 52022,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/species": 55461,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/species.json": 55461,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/spectra": 76102,
	"./resources/assignments/en/chemvlab/stoichiometry/lead_precip/spectra.json": 76102,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/assignment": 37873,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/assignment.json": 37873,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/configuration": 34218,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/configuration.json": 34218,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/reactions": 79032,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/reactions.json": 79032,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/solutions": 16933,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/solutions.json": 16933,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/species": 34882,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/species.json": 34882,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/spectra": 50464,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt/spectra.json": 50464,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/assignment": 96204,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/assignment.json": 96204,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/configuration": 73568,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/configuration.json": 73568,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/reactions": 30679,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/reactions.json": 30679,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/solutions": 58032,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/solutions.json": 58032,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/species": 56809,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/species.json": 56809,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/spectra": 5163,
	"./resources/assignments/en/chemvlab/thermodynamics/Cobalt2/spectra.json": 5163,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/assignment": 62812,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/assignment.json": 62812,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/configuration": 31900,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/configuration.json": 31900,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/reactions": 18162,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/reactions.json": 18162,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/solutions": 5836,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/solutions.json": 5836,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/species": 92532,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/species.json": 92532,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/spectra": 87990,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold1/spectra.json": 87990,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/assignment": 50730,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/assignment.json": 50730,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/configuration": 52003,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/configuration.json": 52003,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/reactions": 82458,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/reactions.json": 82458,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/solutions": 89768,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/solutions.json": 89768,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/species": 40481,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/species.json": 40481,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/spectra": 52063,
	"./resources/assignments/en/chemvlab/thermodynamics/Hotcold2/spectra.json": 52063,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/assignment": 60175,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/assignment.json": 60175,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/configuration": 40662,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/configuration.json": 40662,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/reactions": 15798,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/reactions.json": 15798,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/solutions": 69951,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/solutions.json": 69951,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/species": 43302,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/species.json": 43302,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/spectra": 39467,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar1/spectra.json": 39467,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/assignment": 13652,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/assignment.json": 13652,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/configuration": 13814,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/configuration.json": 13814,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/reactions": 92792,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/reactions.json": 92792,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/solutions": 29450,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/solutions.json": 29450,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/species": 14588,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/species.json": 14588,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/spectra": 24016,
	"./resources/assignments/en/chemvlab/thermodynamics/Solar2/spectra.json": 24016,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/assignment": 57332,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/assignment.json": 57332,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/configuration": 21297,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/configuration.json": 21297,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/reactions": 92129,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/reactions.json": 92129,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/solutions": 48620,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/solutions.json": 48620,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/species": 77890,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/species.json": 77890,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/spectra": 12545,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim1/spectra.json": 12545,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/assignment": 48541,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/assignment.json": 48541,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/configuration": 94868,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/configuration.json": 94868,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/reactions": 30161,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/reactions.json": 30161,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/solutions": 95197,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/solutions.json": 95197,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/species": 73558,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/species.json": 73558,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/spectra": 38966,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim2/spectra.json": 38966,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/assignment": 68722,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/assignment.json": 68722,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/configuration": 41620,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/configuration.json": 41620,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/reactions": 699,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/reactions.json": 699,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/solutions": 69507,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/solutions.json": 69507,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/species": 3824,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/species.json": 3824,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/spectra": 80574,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim3/spectra.json": 80574,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/assignment": 44297,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/assignment.json": 44297,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/configuration": 99328,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/configuration.json": 99328,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/reactions": 4112,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/reactions.json": 4112,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/solutions": 6118,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/solutions.json": 6118,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/species": 23841,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/species.json": 23841,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/spectra": 34964,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim4/spectra.json": 34964,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/assignment": 22667,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/assignment.json": 22667,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/configuration": 68113,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/configuration.json": 68113,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/reactions": 33203,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/reactions.json": 33203,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/solutions": 34295,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/solutions.json": 34295,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/species": 55124,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/species.json": 55124,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/spectra": 92593,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim5/spectra.json": 92593,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/assignment": 20800,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/assignment.json": 20800,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/configuration": 80332,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/configuration.json": 80332,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/reactions": 23466,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/reactions.json": 23466,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/solutions": 57184,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/solutions.json": 57184,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/species": 32374,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/species.json": 32374,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/spectra": 98008,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim6/spectra.json": 98008,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/assignment": 44258,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/assignment.json": 44258,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/configuration": 30815,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/configuration.json": 30815,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/reactions": 68494,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/reactions.json": 68494,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/solutions": 18740,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/solutions.json": 18740,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/species": 13813,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/species.json": 13813,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/spectra": 47093,
	"./resources/assignments/en/chemvlab/thermodynamics/Swim7/spectra.json": 47093,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/assignment": 30425,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/assignment.json": 30425,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/configuration": 95286,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/configuration.json": 95286,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/reactions": 93652,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/reactions.json": 93652,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/solutions": 38530,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/solutions.json": 38530,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/species": 74452,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/species.json": 74452,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/spectra": 44206,
	"./resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/spectra.json": 44206,
	"./resources/assignments/en/colligative/bp_elevation/assignment": 98425,
	"./resources/assignments/en/colligative/bp_elevation/assignment.json": 98425,
	"./resources/assignments/en/colligative/bp_elevation/configuration": 22080,
	"./resources/assignments/en/colligative/bp_elevation/configuration.json": 22080,
	"./resources/assignments/en/colligative/bp_elevation/reactions": 96928,
	"./resources/assignments/en/colligative/bp_elevation/reactions.json": 96928,
	"./resources/assignments/en/colligative/bp_elevation/solutions": 36860,
	"./resources/assignments/en/colligative/bp_elevation/solutions.json": 36860,
	"./resources/assignments/en/colligative/bp_elevation/species": 38454,
	"./resources/assignments/en/colligative/bp_elevation/species.json": 38454,
	"./resources/assignments/en/colligative/bp_elevation/spectra": 98513,
	"./resources/assignments/en/colligative/bp_elevation/spectra.json": 98513,
	"./resources/assignments/en/colligative/vapor_pressure/assignment": 81957,
	"./resources/assignments/en/colligative/vapor_pressure/assignment.json": 81957,
	"./resources/assignments/en/colligative/vapor_pressure/configuration": 35934,
	"./resources/assignments/en/colligative/vapor_pressure/configuration.json": 35934,
	"./resources/assignments/en/colligative/vapor_pressure/reactions": 23089,
	"./resources/assignments/en/colligative/vapor_pressure/reactions.json": 23089,
	"./resources/assignments/en/colligative/vapor_pressure/solutions": 82620,
	"./resources/assignments/en/colligative/vapor_pressure/solutions.json": 82620,
	"./resources/assignments/en/colligative/vapor_pressure/species": 89975,
	"./resources/assignments/en/colligative/vapor_pressure/species.json": 89975,
	"./resources/assignments/en/colligative/vapor_pressure/spectra": 16726,
	"./resources/assignments/en/colligative/vapor_pressure/spectra.json": 16726,
	"./resources/assignments/en/default/assignment": 24364,
	"./resources/assignments/en/default/assignment.json": 24364,
	"./resources/assignments/en/default/configuration": 43174,
	"./resources/assignments/en/default/configuration.json": 43174,
	"./resources/assignments/en/default/reactions": 85180,
	"./resources/assignments/en/default/reactions.json": 85180,
	"./resources/assignments/en/default/solutions": 15300,
	"./resources/assignments/en/default/solutions.json": 15300,
	"./resources/assignments/en/default/species": 27310,
	"./resources/assignments/en/default/species.json": 27310,
	"./resources/assignments/en/default/spectra": 12717,
	"./resources/assignments/en/default/spectra.json": 12717,
	"./resources/assignments/en/hotcoldpack/assignment": 52760,
	"./resources/assignments/en/hotcoldpack/assignment.json": 52760,
	"./resources/assignments/en/hotcoldpack/configuration": 86322,
	"./resources/assignments/en/hotcoldpack/configuration.json": 86322,
	"./resources/assignments/en/hotcoldpack/reactions": 59653,
	"./resources/assignments/en/hotcoldpack/reactions.json": 59653,
	"./resources/assignments/en/hotcoldpack/solutions": 18196,
	"./resources/assignments/en/hotcoldpack/solutions.json": 18196,
	"./resources/assignments/en/hotcoldpack/species": 76418,
	"./resources/assignments/en/hotcoldpack/species.json": 76418,
	"./resources/assignments/en/hotcoldpack/spectra": 67750,
	"./resources/assignments/en/hotcoldpack/spectra.json": 67750,
	"./resources/assignments/en/iron_thiocyanate/assignment": 68534,
	"./resources/assignments/en/iron_thiocyanate/assignment.json": 68534,
	"./resources/assignments/en/iron_thiocyanate/configuration": 54045,
	"./resources/assignments/en/iron_thiocyanate/configuration.json": 54045,
	"./resources/assignments/en/iron_thiocyanate/reactions": 67539,
	"./resources/assignments/en/iron_thiocyanate/reactions.json": 67539,
	"./resources/assignments/en/iron_thiocyanate/solutions": 88311,
	"./resources/assignments/en/iron_thiocyanate/solutions.json": 88311,
	"./resources/assignments/en/iron_thiocyanate/species": 68263,
	"./resources/assignments/en/iron_thiocyanate/species.json": 68263,
	"./resources/assignments/en/iron_thiocyanate/spectra": 62196,
	"./resources/assignments/en/iron_thiocyanate/spectra.json": 62196,
	"./resources/assignments/en/kinetics/cv_bleaching/assignment": 95909,
	"./resources/assignments/en/kinetics/cv_bleaching/assignment.json": 95909,
	"./resources/assignments/en/kinetics/cv_bleaching/configuration": 74319,
	"./resources/assignments/en/kinetics/cv_bleaching/configuration.json": 74319,
	"./resources/assignments/en/kinetics/cv_bleaching/reactions": 69180,
	"./resources/assignments/en/kinetics/cv_bleaching/reactions.json": 69180,
	"./resources/assignments/en/kinetics/cv_bleaching/solutions": 40367,
	"./resources/assignments/en/kinetics/cv_bleaching/solutions.json": 40367,
	"./resources/assignments/en/kinetics/cv_bleaching/species": 18414,
	"./resources/assignments/en/kinetics/cv_bleaching/species.json": 18414,
	"./resources/assignments/en/kinetics/cv_bleaching/spectra": 36531,
	"./resources/assignments/en/kinetics/cv_bleaching/spectra.json": 36531,
	"./resources/assignments/en/kinetics/iodide_persulfate/assignment": 85213,
	"./resources/assignments/en/kinetics/iodide_persulfate/assignment.json": 85213,
	"./resources/assignments/en/kinetics/iodide_persulfate/configuration": 69451,
	"./resources/assignments/en/kinetics/iodide_persulfate/configuration.json": 69451,
	"./resources/assignments/en/kinetics/iodide_persulfate/reactions": 44658,
	"./resources/assignments/en/kinetics/iodide_persulfate/reactions.json": 44658,
	"./resources/assignments/en/kinetics/iodide_persulfate/solutions": 89141,
	"./resources/assignments/en/kinetics/iodide_persulfate/solutions.json": 89141,
	"./resources/assignments/en/kinetics/iodide_persulfate/species": 63940,
	"./resources/assignments/en/kinetics/iodide_persulfate/species.json": 63940,
	"./resources/assignments/en/kinetics/iodide_persulfate/spectra": 50799,
	"./resources/assignments/en/kinetics/iodide_persulfate/spectra.json": 50799,
	"./resources/assignments/en/kinetics/k1/assignment": 501,
	"./resources/assignments/en/kinetics/k1/assignment.json": 501,
	"./resources/assignments/en/kinetics/k1/configuration": 4090,
	"./resources/assignments/en/kinetics/k1/configuration.json": 4090,
	"./resources/assignments/en/kinetics/k1/reactions": 36216,
	"./resources/assignments/en/kinetics/k1/reactions.json": 36216,
	"./resources/assignments/en/kinetics/k1/solutions": 42856,
	"./resources/assignments/en/kinetics/k1/solutions.json": 42856,
	"./resources/assignments/en/kinetics/k1/species": 61346,
	"./resources/assignments/en/kinetics/k1/species.json": 61346,
	"./resources/assignments/en/kinetics/k1/spectra": 61340,
	"./resources/assignments/en/kinetics/k1/spectra.json": 61340,
	"./resources/assignments/en/kinetics/k2/assignment": 31398,
	"./resources/assignments/en/kinetics/k2/assignment.json": 31398,
	"./resources/assignments/en/kinetics/k2/configuration": 31853,
	"./resources/assignments/en/kinetics/k2/configuration.json": 31853,
	"./resources/assignments/en/kinetics/k2/reactions": 67009,
	"./resources/assignments/en/kinetics/k2/reactions.json": 67009,
	"./resources/assignments/en/kinetics/k2/solutions": 69566,
	"./resources/assignments/en/kinetics/k2/solutions.json": 69566,
	"./resources/assignments/en/kinetics/k2/species": 4698,
	"./resources/assignments/en/kinetics/k2/species.json": 4698,
	"./resources/assignments/en/kinetics/k2/spectra": 61207,
	"./resources/assignments/en/kinetics/k2/spectra.json": 61207,
	"./resources/assignments/en/kinetics/k3/assignment": 68272,
	"./resources/assignments/en/kinetics/k3/assignment.json": 68272,
	"./resources/assignments/en/kinetics/k3/configuration": 80871,
	"./resources/assignments/en/kinetics/k3/configuration.json": 80871,
	"./resources/assignments/en/kinetics/k3/reactions": 396,
	"./resources/assignments/en/kinetics/k3/reactions.json": 396,
	"./resources/assignments/en/kinetics/k3/solutions": 58016,
	"./resources/assignments/en/kinetics/k3/solutions.json": 58016,
	"./resources/assignments/en/kinetics/k3/species": 26634,
	"./resources/assignments/en/kinetics/k3/species.json": 26634,
	"./resources/assignments/en/kinetics/k3/spectra": 88048,
	"./resources/assignments/en/kinetics/k3/spectra.json": 88048,
	"./resources/assignments/en/kinetics/k4equilibrium/assignment": 16814,
	"./resources/assignments/en/kinetics/k4equilibrium/assignment.json": 16814,
	"./resources/assignments/en/kinetics/k4equilibrium/configuration": 22722,
	"./resources/assignments/en/kinetics/k4equilibrium/configuration.json": 22722,
	"./resources/assignments/en/kinetics/k4equilibrium/reactions": 64117,
	"./resources/assignments/en/kinetics/k4equilibrium/reactions.json": 64117,
	"./resources/assignments/en/kinetics/k4equilibrium/solutions": 2872,
	"./resources/assignments/en/kinetics/k4equilibrium/solutions.json": 2872,
	"./resources/assignments/en/kinetics/k4equilibrium/species": 78185,
	"./resources/assignments/en/kinetics/k4equilibrium/species.json": 78185,
	"./resources/assignments/en/kinetics/k4equilibrium/spectra": 11069,
	"./resources/assignments/en/kinetics/k4equilibrium/spectra.json": 11069,
	"./resources/assignments/en/metals/assignment": 2678,
	"./resources/assignments/en/metals/assignment.json": 2678,
	"./resources/assignments/en/metals/configuration": 50355,
	"./resources/assignments/en/metals/configuration.json": 50355,
	"./resources/assignments/en/metals/reactions": 56771,
	"./resources/assignments/en/metals/reactions.json": 56771,
	"./resources/assignments/en/metals/solutions": 60792,
	"./resources/assignments/en/metals/solutions.json": 60792,
	"./resources/assignments/en/metals/species": 39664,
	"./resources/assignments/en/metals/species.json": 39664,
	"./resources/assignments/en/metals/spectra": 29379,
	"./resources/assignments/en/metals/spectra.json": 29379,
	"./resources/assignments/en/solubility/assignment": 17952,
	"./resources/assignments/en/solubility/assignment.json": 17952,
	"./resources/assignments/en/solubility/configuration": 18402,
	"./resources/assignments/en/solubility/configuration.json": 18402,
	"./resources/assignments/en/solubility/reactions": 40212,
	"./resources/assignments/en/solubility/reactions.json": 40212,
	"./resources/assignments/en/solubility/solutions": 61912,
	"./resources/assignments/en/solubility/solutions.json": 61912,
	"./resources/assignments/en/solubility/species": 81104,
	"./resources/assignments/en/solubility/species.json": 81104,
	"./resources/assignments/en/solubility/spectra": 32418,
	"./resources/assignments/en/solubility/spectra.json": 32418,
	"./resources/assignments/en/test/assignment": 44237,
	"./resources/assignments/en/test/assignment.json": 44237,
	"./resources/assignments/en/test/configuration": 76010,
	"./resources/assignments/en/test/configuration.json": 76010,
	"./resources/assignments/en/test/reactions": 78526,
	"./resources/assignments/en/test/reactions.json": 78526,
	"./resources/assignments/en/test/solutions": 39223,
	"./resources/assignments/en/test/solutions.json": 39223,
	"./resources/assignments/en/test/species": 20720,
	"./resources/assignments/en/test/species.json": 20720,
	"./resources/assignments/en/test/spectra": 2839,
	"./resources/assignments/en/test/spectra.json": 2839,
	"./resources/assignments/es/default/assignment": 10917,
	"./resources/assignments/es/default/assignment.json": 10917,
	"./resources/assignments/es/default/configuration": 55468,
	"./resources/assignments/es/default/configuration.json": 55468,
	"./resources/assignments/es/default/reactions": 13394,
	"./resources/assignments/es/default/reactions.json": 13394,
	"./resources/assignments/es/default/solutions": 38491,
	"./resources/assignments/es/default/solutions.json": 38491,
	"./resources/assignments/es/default/species": 53179,
	"./resources/assignments/es/default/species.json": 53179,
	"./resources/assignments/es/default/spectra": 69584,
	"./resources/assignments/es/default/spectra.json": 69584,
	"./resources/assignments_chemv_en": 36000,
	"./resources/assignments_chemv_en.json": 36000,
	"./resources/assignments_en": 87005,
	"./resources/assignments_en.json": 87005,
	"./resources/assignments_es": 22651,
	"./resources/assignments_es.json": 22651,
	"./resources/glassware": 74834,
	"./resources/glassware.js": 74834,
	"./resources/lang": 66567,
	"./resources/lang.js": 66567,
	"./resources/reactions": 96015,
	"./resources/reactions.js": 96015,
	"./resources/solutions": 14339,
	"./resources/solutions.js": 14339,
	"./resources/species": 2000,
	"./resources/species.js": 2000,
	"./resources/tools": 88969,
	"./resources/tools.js": 88969,
	"./resources/vessels": 47239,
	"./resources/vessels.js": 47239,
	"./templates/1000mLBeaker.ejs": 69373,
	"./templates/1000mLFlask.ejs": 34477,
	"./templates/1000mLVolumetricFlask.ejs": 76155,
	"./templates/100mLBottle.ejs": 11919,
	"./templates/100mLGraduatedCylinder.ejs": 82514,
	"./templates/100mLVolumetricFlask.ejs": 78909,
	"./templates/100mlGraduatedEmpty-Plain-min-2.svg": 97182,
	"./templates/100mlGraduatedEmpty-min.svg": 15726,
	"./templates/10mLGraduatedCylinder.ejs": 56316,
	"./templates/10mLPipette.ejs": 21955,
	"./templates/2500mLBottle.ejs": 6114,
	"./templates/250mL-Flask-Stopper-selection.svg": 36769,
	"./templates/250mL-Flask-Stopper-svg.svg": 63543,
	"./templates/250mL-Flask-Stopper.afdesign": 15020,
	"./templates/250mLBeaker.ejs": 43587,
	"./templates/250mLFlask.ejs": 88655,
	"./templates/250mLFlask.svg": 67299,
	"./templates/250mLStopperedFlask.ejs": 3893,
	"./templates/250mLVolumetricFlask.ejs": 76451,
	"./templates/25mLGraduatedCylinder.ejs": 48449,
	"./templates/25mLPipette.ejs": 99486,
	"./templates/3LCarboy.ejs": 96080,
	"./templates/500mLFlask.ejs": 55178,
	"./templates/500mLVolumetricFlask.ejs": 19662,
	"./templates/50mLBurette.ejs": 84714,
	"./templates/50mLGraduatedCylinder.ejs": 84713,
	"./templates/50mlGraduatedEmpty-Plain.svg": 27075,
	"./templates/50mlGraduatedEmpty.svg": 49146,
	"./templates/5mLPipette.ejs": 80233,
	"./templates/600mLBeaker.ejs": 90736,
	"./templates/App.ejs": 32616,
	"./templates/Assignment.ejs": 58431,
	"./templates/AssignmentTextModal.ejs": 22142,
	"./templates/DisposablePipette.ejs": 10071,
	"./templates/InstrumentPanel.ejs": 69850,
	"./templates/LanguageModal.ejs": 29775,
	"./templates/Modal.ejs": 85410,
	"./templates/Nav.ejs": 34817,
	"./templates/RenameWorkbenchModal.ejs": 51901,
	"./templates/Stockroom.ejs": 35952,
	"./templates/TipsModal.ejs": 81338,
	"./templates/Vessel.ejs": 80619,
	"./templates/Workbench.ejs": 33635,
	"./templates/assignmentModal.ejs": 76855,
	"./templates/bunsenBurner.ejs": 22622,
	"./templates/foamCup.ejs": 258,
	"./templates/scale.ejs": 63405,
	"./templates/solidBottle.ejs": 62698,
	"./templates/weighBoat.ejs": 29700,
	"./torus/TorusMessager": 30074,
	"./torus/TorusMessager.js": 30074,
	"./unknownacid1": 87496,
	"./unknownacid1.js": 87496,
	"./util/clamp": 14284,
	"./util/clamp.js": 14284,
	"./util/helpers": 71849,
	"./util/helpers.js": 71849,
	"./views/App": 69649,
	"./views/App.js": 69649,
	"./views/App.js~": 71737,
	"./views/Assignment": 33296,
	"./views/Assignment.js": 33296,
	"./views/InstrumentPanel": 80621,
	"./views/InstrumentPanel.js": 80621,
	"./views/Nav": 59523,
	"./views/Nav.js": 59523,
	"./views/Nav.js~": 97870,
	"./views/Stockroom": 17650,
	"./views/Stockroom.js": 17650,
	"./views/Stockroom.js~": 65073,
	"./views/Tool": 89223,
	"./views/Tool.js": 89223,
	"./views/Vessel": 89666,
	"./views/Vessel.js": 89666,
	"./views/Workbench": 70301,
	"./views/Workbench.js": 70301,
	"./views/replaceUnknowns": 53948,
	"./views/replaceUnknowns.js": 53948,
	"./views/replaceUnknowns.test": 46663,
	"./views/replaceUnknowns.test.js": 46663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63603;